import { render, staticRenderFns } from "./FavoritosMobile.vue?vue&type=template&id=476a3b48&scoped=true&"
import script from "./FavoritosMobile.vue?vue&type=script&lang=js&"
export * from "./FavoritosMobile.vue?vue&type=script&lang=js&"
import style0 from "./FavoritosMobile.vue?vue&type=style&index=0&id=476a3b48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476a3b48",
  null
  
)

export default component.exports